import {
  AcademicCapIcon,
  ClockIcon,
  DocumentCheckIcon,
  EyeSlashIcon,
  LockClosedIcon,
  MagnifyingGlassIcon,
  MapPinIcon,
  ServerStackIcon
} from '@heroicons/react/24/outline'

import { anim, prog } from '../motion'
import { Box, COLORS } from '../primitives'

// Schritte: 0 Hosting und DSGVO · 1 Kontrolle · 2 Fundierte Entscheidungen
const BADGES = [
  {
    Icon: ServerStackIcon,
    title: 'ISO 27001',
    sub: 'zertifizierte Server',
    color: 'blue',
    x: 40,
    y: 80,
    at: [0.04, 0.11]
  },
  {
    Icon: MapPinIcon,
    title: 'Standort Deutschland',
    sub: 'Hosting in Deutschland',
    color: 'blue',
    x: 40,
    y: 220,
    at: [0.08, 0.15]
  },
  {
    Icon: DocumentCheckIcon,
    title: 'DSGVO-konform',
    sub: 'Datenschutz nach EU-Recht',
    color: 'blue',
    x: 40,
    y: 360,
    at: [0.12, 0.19]
  },
  {
    Icon: ClockIcon,
    title: 'Automatische Löschung',
    sub: 'nach deiner Frist',
    color: 'green',
    x: 650,
    y: 80,
    at: [0.38, 0.45]
  },
  {
    Icon: EyeSlashIcon,
    title: 'Score ausblendbar',
    sub: 'per Einstellung im Report',
    color: 'green',
    x: 650,
    y: 220,
    at: [0.42, 0.49]
  },
  {
    Icon: AcademicCapIcon,
    title: 'DIN 33430',
    sub: 'Anforderungsanalyse',
    color: 'yellow',
    x: 650,
    y: 360,
    at: [0.7, 0.77]
  },
  {
    Icon: MagnifyingGlassIcon,
    title: 'Nachvollziehbar',
    sub: 'regelbasierte Passung',
    color: 'yellow',
    x: 345,
    y: 520,
    at: [0.74, 0.81]
  }
]

const SHIELD =
  'M120 8 L224 46 V138 C224 204 180 250 120 272 C60 250 16 204 16 138 V46 Z'

export default function SceneSecurity() {
  return (
    <>
      <Box x={360} y={110} w={240} h={280}>
        <svg
          viewBox='0 0 240 280'
          width={240}
          height={280}
          aria-hidden='true'
          className='sty-overflow'
        >
          <path
            d={SHIELD}
            fill={COLORS.blue}
            style={{ ...prog([0.1, 0.18]), opacity: 'var(--p)' }}
          />
          <path
            d={SHIELD}
            fill='none'
            stroke={COLORS.blue}
            strokeWidth={6}
            strokeLinejoin='round'
            pathLength={1}
            style={{
              ...prog([0, 0.12]),
              strokeDasharray: 1,
              strokeDashoffset: 'calc(1 - var(--p))'
            }}
          />
        </svg>
        <div
          className='sty-abs sty-shield-icon'
          style={anim({ at: [0.14, 0.2], s: 0.4, y: 0 })}
        >
          <LockClosedIcon width={72} height={72} color='#fff' />
        </div>
      </Box>

      {BADGES.map(({ Icon, title, sub, color, x, y, at }) => (
        <Box
          key={title}
          x={x}
          y={y}
          w={270}
          h={96}
          className='sty-card sty-pad sty-row'
          style={anim({
            at,
            x: x < 360 ? -30 : x > 600 ? 30 : 0,
            y: x === 345 ? 30 : 0
          })}
        >
          <span className='sty-icon-tile' style={{ background: COLORS[color] }}>
            <Icon width={24} height={24} color='#fff' />
          </span>
          <div>
            <div className='sty-strong'>{title}</div>
            <div className='sty-muted sty-small'>{sub}</div>
          </div>
        </Box>
      ))}
    </>
  )
}
